import { fork, all } from "redux-saga/effects";
import ExportSaga from "../customWidgets/ExportExcel/Store/saga";
import UserAccessSaga from "./saga";

export default function* rootSaga() {
    yield all([fork(ExportSaga), fork(UserAccessSaga)])
}